import { AUDITS_DATA, AUDITS_START,AUDITS_END} from "../type";
import { validateToken, redirectToLogin } from '../../../utils/auth/tokenValidation';

interface Action {
  type: string;
  payload?: any; 
  loading?: boolean;
}

type Dispatch = (action: Action) => void;


const API_URL = process.env.REACT_APP_API_URL



export const getAudits = (params: any) => async (dispatch: Dispatch): Promise<void> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return;
  }
  
  try {
    dispatch({
      type: AUDITS_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }


     const query = new URLSearchParams({
        fromDate: params.fromDate,
        toDate: params.toDate,
        userId: String(params.userId),
        username: params.username || "",
        ipAddress: params.ipAddress || "",
        actionName: params.actionName || "",
        isException: String(params.isException),
        page: String(params.page),
        size: String(params.size),
        sortBy: params.sortBy,
        direction: params.direction,
      }).toString();

    const response = await fetch(`${API_URL}/api/activity/logs?${query}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: AUDITS_DATA,
        payload: [{ res }], 
        loading: false,
      });
    } else {
      const res = await response.json();
      dispatch({
        type: AUDITS_END,
        payload: [{ res }], 
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: AUDITS_END,
      payload: false,
      loading: false,
    });
    console.error(error);
  }
};


